import { RemoveCartItem, ShoppingCart } from '@buy-viasat/types/build/bv';
import { mapRestCartToGqlCart, RestShoppingCart } from './upsertCartAddonsRest';
import api, { apiEndpoints } from 'shared/services/axios';

export async function removeCartItemRest(input: RemoveCartItem): Promise<ShoppingCart> {
  const response = await api.post<RestShoppingCart>(apiEndpoints.removeCartItem, input);
  return mapRestCartToGqlCart(response.data);
}
